import {
  MembershipTypes,
  useAuthContext,
  useMembershipConfigContext,
} from '@r-and-a-shared-ui/auth-client';
import { RestrictionLevel } from '../MembershipTypeLogos/constants';
import { useAccessRestrictedContent } from '../../hooks/useAccessRestrictedContent';

type RestrictedContentPromptProps = {
  access?: keyof typeof RestrictionLevel;
};

export const useRestrictedContentPrompt = ({
  access,
}: RestrictedContentPromptProps) => {
  const { userHasAccess } = useAccessRestrictedContent({ access });
  const { restrictedContentPrompt = [] } = useMembershipConfigContext() ?? {};
  const {
    userState: { membership, isAuthenticated = true },
  } = useAuthContext();

  const fallbackTitle = isAuthenticated
    ? membership.type === MembershipTypes.OneClub
      ? `Upgrade to Unlock`
      : ``
    : `You're not on par!`;

  const fallbackSubtitle = isAuthenticated
    ? membership.type === MembershipTypes.OneClub
      ? `Upgrade to unlock Exclusive Content, Premium Rewards and Benefits`
      : ``
    : `Login/Sign Up to unlock Exclusive Content, Premium Rewards and Benefits`;

  const accessLevel = isAuthenticated
    ? membership.type === MembershipTypes.OneClub
      ? 'oneclub'
      : 'oneclubadvantage'
    : 'none';


  const prompt = restrictedContentPrompt?.restrictedContentPrompts?.find(
    (item: { access: string; }) => item?.access === accessLevel);

  const titleText = prompt?.text || fallbackTitle;
  const subtitleText = prompt?.subtext || fallbackSubtitle;

  return {
    userHasAccess,
    titleText,
    subtitleText,
  };
};
